import { createQueryKeySet } from '~/utils/query-keys';
import { useQuery } from '@tanstack/react-query';
import { SSF } from '~/apis/api';

export const keys = createQueryKeySet('referee.roles');

export function useRefereeRoleListQuery() {
  return useQuery({
    queryFn: async () => {
      const { data } = await SSF.api.judgeRolesList();
      return data;
    },
    queryKey: keys.list(),
  });
}
